import {createContext} from "react";


export const ButtonsSectionContext = createContext(null)